/* @flow */
import React from 'react';
import { Drawer } from 'antd';
import { RouterProps } from 'react-router';
import SideMenu from './SideMenu';
import { getFlatMenuKeys } from './utils';

type Props = {
  isMobile: boolean,
  menuData: any,
  isCollapsed: boolean,
  onCollapse: (isCollapsed: boolean) => void,
  menuItems: Array<MenuItemsT>,
  logo: string,
  router: RouterProps,
  settings: SettingsT,
};

const SideMenuWrapper = (props: Props) => {
  const { isMobile, menuData, isCollapsed, onCollapse } = props;
  const flatMenuKeys = getFlatMenuKeys(menuData);
  return isMobile ? (
    <Drawer
      visible={!isCollapsed}
      placement="left"
      onClose={() => onCollapse(true)}
      style={{
        padding: 0,
        height: '100vh',
      }}
    >
      <SideMenu {...props} flatMenuKeys={flatMenuKeys} isCollapsed={isMobile ? false : isCollapsed} />
    </Drawer>
  ) : (
    <SideMenu {...props} flatMenuKeys={flatMenuKeys} />
  );
};

export default SideMenuWrapper;
